import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import {
  ASSIGN_QUESTIONS_TO_FORM_SECTION,
  GET_FORM,
  get_headers,
  get_project_id,
  GET_SECTIONS_IN_FORM,
  get_token,
  QUESTION_TYPE_URLS,
  SECTIONS_LIST_URLS,
  SELECT_TYPES,
  UNASSIGN_QUESTIONS_TO_FORM_SECTION
} from "@/utils/constants/constants";
import alert_mixin from "@/utils/mixins/alert_mixin";
import create_questions_crud_mixins from '@/utils/mixins/create_questions_crud_mixins';
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import CreateQuestions from "@/views/probaworkflows_base/management/survey_managment/create_questions/CreateQuestions.vue";
import CreateSections from "@/views/probaworkflows_base/management/survey_managment/create_sections/CreateSections.vue";
import PreviewForm from "@/views/probaworkflows_base/management/survey_managment/preview_form/PreviewForm.vue";
import axios from "axios";
import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.css";
import $ from "jquery";
import Swal from "sweetalert2";
import { nextTick } from "vue";

export default {
  name: "CreateEntity",
  mixins: [alert_mixin, formatting_mixins, create_questions_crud_mixins],
  components: { GlobalTable, CreateSections, CreateQuestions, PreviewForm },

  data: () => ({
    removed_question_ids: [],
    question_types: [],
    section_types: [],
    token: get_token(),
    headers: get_headers(),
    project_id: get_project_id(),
    form_id: null,
    active_tab: "Manage Forms",
    sub_active_tab: "Sections",
    tabs: [
      "Manage Forms", "Manage Template", "Manage Approval Rules",
      "Manage Invoice Steps", "Manage Compliance"
    ],
    sub_tabs: ["Sections", "Create Questions", "Preview Form"],
    section_list: [],
    section_table_headers: [],
    table_safe_section_list: [],
    preview_sections: [],
    question_forms: [],
    show_edit_section_modal: false,
    show_edit_modal: false,
    show_dependent_modal: false,
    current_edit_section: { id: null, name: '', order: null },
    current_edit_question: null,
    section_name_error: false,
    section_name: "",
    option_inputs: ['', ''],
    available_tags: [],
    selected_tag_id: null,
    current_main_question_id: null,
    current_main_question_index: null,
    section_id: ""
  }),

  computed: {
    filtered_data() {
      const data_map = {
        "Create Questions": this.question_forms,
        "Preview Form": this.preview_sections
      };
      return data_map[this.sub_active_tab] || [];
    },
    check_question_type() {
      const type = this.question_types.find(t => t.id === this.question_type_id);
      return SELECT_TYPES.includes(type?.question_type);
    },
    parent_question_options() {
      if (!this.current_main_question_id) return [];
      const parent_question = this.question_forms.find(q => q.id === this.current_main_question_id);
      if (!parent_question || !this.is_select_type(parent_question.question_type_id)) return [];
      return parent_question.option_inputs || [];
    }
  },

  methods: {

    create_empty_question_form: () => ({
      id: Date.now(),
      question_text: "",
      question_number: "",
      question_type_id: "",
      mandatory: "",
      option_inputs: ['', ''],
      show_option_inputs: false,
      tag_id: null,
      available_tags: [],
      dependant_questions: [],
      show_dependent_section: false
    }),

    create_empty_edit_question: () => ({
      id: null,
      question_index: null,
      question_text: '',
      question_type: '',
      question_type_id: '',
      options: [],
      show_option_inputs: false,
      tag_id: null,
      available_tags: [],
      dependant_questions: []
    }),

    is_select_type(question_type_id) {
      const type = this.question_types.find(t => t.id === question_type_id);
      return type ? SELECT_TYPES.includes(type.question_type) : false;
    },




    assign_question(section_id) {
      if (!this.form_id) {
        this.show_error('Please save the form first');
        return;
      }
      sessionStorage.setItem('current_form_id', this.form_id);
      sessionStorage.setItem('current_section_id', section_id);
      this.$router.push({
        path: '/manage_questions',
        query: { form_id: this.form_id, section_id, project_id: this.project_id }
      });
    },

    handle_question_type_change(form) {
      const type = this.question_types.find(t => t.id === form.question_type_id);
      form.show_option_inputs = SELECT_TYPES.includes(type?.question_type);
      if (form.show_option_inputs) {
        form.option_inputs = form.option_inputs?.length >= 2 ? form.option_inputs : ['', ''];
      } else {
        form.option_inputs = [];
      }
    },

    add_option_input(form) {
      form.option_inputs.push('');
    },

    remove_option_input(index, form) {
      if (form.option_inputs.length > 2) {
        form.option_inputs.splice(index, 1);
      }
    },

    set_edit_question_data(question, question_index) {
      if (!question?.id) throw new Error('Question data incomplete');

      const question_type = this.question_types.find(
        t => t.question_type === question.question_type?.question_type
      );

      const options = (question.multi_select_choices || question.options || []).map(opt => {
        if (typeof opt === 'object') {
          return {
            choice: opt.choice || '',
            id: opt.id
          };
        }
        return { choice: opt || '' };
      });

      this.current_edit_question = {
        id: question.id.toString(),
        question_index,
        question_text: question.question_text || '',
        question_type: question.question_type?.question_type || '',
        question_type_id: question_type?.id?.toString() || '',
        options: options.length ? options : [{ choice: '' }],
        show_option_inputs: SELECT_TYPES.includes(question.question_type?.question_type || ''),
        tag_id: question.tag_id || null,
        tag: question.tag || null,
        dependant_questions: question.dependant_questions || []
      };

      this.option_inputs = options.map(opt => opt.choice);
    },

    edit_preview_question(question, question_index) {
      try {
        this.set_edit_question_data(question, question_index);
        this.show_edit_modal = true;
      } catch (error) {
        this.show_error(error.message);
      }
    },

    async unassign_question(question_id, form_section_id) {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'This will remove the question from this section only!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, remove it!'
      });

      if (!result.isConfirmed) return;

      try {
        const payload = {
          question_ids: [question_id],
          form_section_id,
          project_id: this.project_id,
          form_id: this.form_id
        };

        await axios.post(UNASSIGN_QUESTIONS_TO_FORM_SECTION, payload, { headers: this.headers });

        this.preview_sections = this.preview_sections.map(section =>
          section.id === form_section_id ? {
            ...section,
            questions: section.questions?.filter(q => q.id !== question_id) || []
          } : section
        );

        this.show_success('Question removed');
        this.get_form_to_preview();
      } catch (error) {
        const error_msg = error.response?.data?.message || error.response?.data?.detail || 'Removal failed';
        this.show_error(error_msg);
      }
    },

    async fetch_sections() {
      try {
        const { data } = await axios.get(SECTIONS_LIST_URLS, { headers: this.headers });
        this.section_types = data.data || [];
      } catch (error) {
        this.show_error(`Error fetching sections: ${error.response?.data?.message || error.message}`);
      }
    },

    open_edit_section_modal(section) {
      this.current_edit_section = {
        id: section.id,
        name: section.section_name,
        order: section.order
      };
      this.show_edit_section_modal = true;
      this.section_name_error = false;
    },

    async get_data_point_types() {
      try {
        const { data } = await axios.get(QUESTION_TYPE_URLS, { headers: this.headers });
        const types = typeof data === 'string' ? JSON.parse(data) : data;
        this.question_types = types.data.map(item => ({
          ...item,
          formatted_type: this.format_question_type(item.question_type),
        }));
      } catch (error) {
        this.show_error(`Error retrieving question types: ${error.message}`);
      }
    },

    async get_sections() {
      this.section_list = [];
      try {
        const { data } = await axios.post(GET_SECTIONS_IN_FORM,
          { form_id: this.form_id },
          { headers: this.headers }
        );

        if (data?.data?.length) {
          this.section_list = data.data;
          this.prep_tables();
        }
      } catch (error) {
        if (error.response?.status !== 404) {
          this.show_error(`Error getting sections: ${error.response?.data?.message || error.message}`);
        }
      }
    },

    prep_tables() {
      if (this.section_list.length) {
        this.table_safe_section_list = this.section_list.map(section => ({
          id: section.section_id,
          section_name: section.section_name,
        }));
        this.section_table_headers = Object.keys(this.table_safe_section_list[0]);
      }
      this.initialize_data_table();
    },

    async get_form_to_preview() {
      try {
        const { data } = await axios.get(GET_FORM, {
          headers: this.headers,
          params: { form_id: this.form_id },
        });

        this.preview_sections = (data.data?.sections || []).map(section => ({
          id: section.id,
          name: section.name,
          order: section.order_number,
          questions: (section.questions || [])
            .filter(q => !this.removed_question_ids.includes(q.id))
            .map(question => ({
              id: question.id,
              question_text: question.question_text,
              question_type: {
                question_type: question.question_type.question_type,
                id: question.question_type.id
              },
              is_mandatory: question.is_mandatory,
              question_number: question.question_number,
              options: question.options || [],
              multi_select_choices: question.multi_select_choices || [],
              dependant_questions: question.dependant_questions || []
            }))
        }));
      } catch (error) {
        this.show_error(`Error getting form: ${error.response?.data?.message || error.message}`);
      }
    },

    async set_active_tab(tab) {
      this.active_tab = tab;
      await nextTick();
      this.initialize_data_table();
    },

    async set_sub_active_tab(tab) {
      this.sub_active_tab = tab;
      await nextTick();
      this.initialize_data_table();
    },

    initialize_data_table() {
      this.$nextTick(() => {
        const table_map = {
          Sections: "#create-sections-table",
        };

        const table_id = table_map[this.sub_active_tab];
        if (!table_id || !document.querySelector(table_id)) return;

        if ($.fn.DataTable.isDataTable(table_id)) {
          $(table_id).DataTable().destroy();
        }

        $(table_id).DataTable({ responsive: true, destroy: true });
      });
    },

    add_question_form() {
      this.question_forms.push(this.create_empty_question_form());
    },

    remove_question_form(index) {
      this.question_forms.splice(index, 1);
    },

    async assign_questions_to_section(question_ids, section_id, is_mandatory = false ) {
      if (!question_ids?.length || !section_id ) return null;

      try {
        const payload = {
          project_id: this.project_id,
          form_id: this.form_id,
          section_id,
          question_ids,
          is_mandatory: is_mandatory,
        };

        const { data } = await axios.post(
          ASSIGN_QUESTIONS_TO_FORM_SECTION,
          payload,
          { headers: this.headers }
        );

        const response = typeof data === "string" ? JSON.parse(data) : data;
        if (response.success) {
          this.show_success("Question assigned to section");
          this.get_form_to_preview();
        }
        return response;
      } catch (error) {
        this.show_error(`Error assigning question: ${error.response?.data?.message || error.message}`);
        return null;
      }
    },

    reset_question_form() {
      this.question_forms = [this.create_empty_question_form()];
      this.option_inputs = ['', ''];
    },

    go_back_to_view_entity_type() {
      this.$router.push("/view_entity_type");
    }
  },

  mounted() {
    this.form_id = this.$route.query.form_id;
    this.question_forms = [this.create_empty_question_form()];
    this.current_edit_question = this.create_empty_edit_question();
    this.headers = get_headers();
    this.get_sections();
    this.get_data_point_types();
    this.get_form_to_preview();
    this.initialize_data_table();
  },

  watch: {
    question_type_id() {
      this.handle_question_type_change(this);
    },
    create_sections: 'initialize_data_table',
    create_questions: 'initialize_data_table',
    preview_form: 'initialize_data_table'
  }
};